export const palettes = {
    "grey": {
        title: 'Grey', primary: '#444957', primaryLight: '#6f7484', primaryDark: '#1d222e', primaryText: '#fff',
        secondary: '#4caf50', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    },
    "indigo": {
        title: 'Indigo', primary: '#3f51b5', primaryLight: '#757de8', primaryDark: '#002984', primaryText: '#fff', 
        secondary: '#8bc34a', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    },
    "blue": {
        title: 'Blue', primary: '#11a7d9', primaryLight: '#64d9ff', primaryDark: '#0078a7', primaryText: '#fff', 
        secondary: '#002b45', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    },
    "pink": {
        title: 'Pink', primary: '#e91e63', primaryLight: '#ff6090', primaryDark: '#b0003a', primaryText: '#fff', 
        secondary: '#8bc34a', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    },
    "green": {
        title: 'Green', primary: '#009688', primaryLight: '#52c7b8', primaryDark: '#00675b', primaryText: '#fff', 
        secondary: '#4caf50', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    },
    "purple": {
        title: 'Purple', primary: '#9c27b0', primaryLight: '#d05ce3', primaryDark: '#6a0080', primaryText: '#fff', 
        secondary: '#4caf50', background: '#fff', secondaryText: '#fff',
        success: '#5ab031', error: '#dc0a36', warning: '#ffeb3b', progressBar: '#5ab031', progressRoot: '#dc0a36'
    }
};